"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInCommand = void 0;
class SignInCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { cdp: cdpTracking } = config;
        const { customer } = this.input;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('user', 'sign_in', {
            ...(customer && {
                dims: {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                },
            }),
            extra: {},
        });
        return Promise.resolve();
    }
}
exports.SignInCommand = SignInCommand;
